import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AppSettings } from '../../app.settings';
import type { Status } from '../../models/status';
import { EntityService } from '../../services/entity.service';
import { MiImageContainerComponent } from '../../ui-sharable/mi-image-container/mi-image-container.component';
import { KeyValuePipe, NgClass, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-status',
  standalone: true,
  imports: [OverlayPanelModule, MiImageContainerComponent, KeyValuePipe, NgClass, JsonPipe],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss'
})
export class StatusComponent implements OnInit {
  @Input() public dataForStatus: Array<Status> = [];
  @Input() public dataForVehicleStatus: Array<Status> = [];
  @Input() public userId: Array<Status> = [];
  @Input() public imgFileId: string;
  @Input() public imgFileUrl: string;
  @Input() public entityForStatus: any;
  @Input() public showImage: any = true;
  imageBase64: any;
  defaultLoaderImg = AppSettings.DEFAULT_LOADER_IMAGE;

  constructor(
    private statusService: EntityService,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (this.imgFileId) {
      this.getImage();
    } else {
      this.imageBase64 = AppSettings.DEFAULT_LOADER_IMAGE;
    }
  }

  getImage() {
    this.statusService.getFile(this.imgFileId, AppSettings.DOCUMENTS_TYPE.PROFILE).subscribe(result => {
      const reader = new FileReader();
      reader.readAsDataURL(result);
      reader.onloadend = () => {
        const base64data = reader.result;
        this.imageBase64 = base64data;
        this.cd.detectChanges();
      }
    })
  }
}
